import { render, staticRenderFns } from "./treeselect.vue?vue&type=template&id=535fd824&scoped=true"
import script from "./treeselect.vue?vue&type=script&lang=js"
export * from "./treeselect.vue?vue&type=script&lang=js"
import style0 from "./treeselect.vue?vue&type=style&index=0&id=535fd824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535fd824",
  null
  
)

export default component.exports